import { connect } from 'react-redux';
import DriftChat from 'common/components/drift_chat';

const mapStateToProps = ({ user, categories }) => {
  return {
    shouldShow: !user.logged_in || user.profile_data.is_client,
    user: user.profile_data,
    categories
  };
}

export default connect(mapStateToProps)(DriftChat);
